module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "d.40b300f8.png";